// Currency formatting helpers for multi-currency personal finance.
// Uses Intl.NumberFormat with explicit locale + currency code.

export const SUPPORTED_CURRENCIES = [
  { code: 'BRL', symbol: 'R$',  label: 'Real Brasileño',     locale: 'pt-BR' },
  { code: 'USD', symbol: '$',   label: 'US Dollar',          locale: 'en-US' },
  { code: 'EUR', symbol: '€',   label: 'Euro',               locale: 'es-ES' },
  { code: 'COP', symbol: 'COL$',label: 'Peso Colombiano',    locale: 'es-CO' },
  { code: 'MXN', symbol: 'MX$', label: 'Peso Mexicano',      locale: 'es-MX' },
  { code: 'ARS', symbol: 'AR$', label: 'Peso Argentino',     locale: 'es-AR' },
  { code: 'CLP', symbol: 'CLP$',label: 'Peso Chileno',       locale: 'es-CL' },
  { code: 'PEN', symbol: 'S/.', label: 'Sol Peruano',        locale: 'es-PE' },
  { code: 'GBP', symbol: '£',   label: 'Libra Esterlina',    locale: 'en-GB' }
];

export const DEFAULT_CURRENCY = 'BRL';
export const DEFAULT_LOCALE   = 'pt-BR';

const _formatterCache = new Map();

function getFormatter(currency, locale) {
  const key = `${locale}|${currency}`;
  if (!_formatterCache.has(key)) {
    try {
      _formatterCache.set(
        key,
        new Intl.NumberFormat(locale, {
          style: 'currency',
          currency,
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        })
      );
    } catch (e) {
      _formatterCache.set(
        key,
        new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        })
      );
    }
  }
  return _formatterCache.get(key);
}

export function formatCurrency(
  value,
  currency = DEFAULT_CURRENCY,
  locale = DEFAULT_LOCALE
) {
  const amount = Number(value);
  if (!isFinite(amount)) return getFormatter(currency, locale).format(0);
  return getFormatter(currency, locale).format(amount);
}

export function formatCurrencyShort(
  value,
  currency = DEFAULT_CURRENCY,
  locale = DEFAULT_LOCALE
) {
  // No decimals — useful for compact dashboard cards.
  const amount = Number(value) || 0;
  try {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(amount);
  } catch {
    return formatCurrency(value, currency, locale);
  }
}

export function getCurrencyMeta(code) {
  return SUPPORTED_CURRENCIES.find((c) => c.code === code) ||
         SUPPORTED_CURRENCIES[0];
}
